<template>
    <div>
        <div class="content-body">
            <div class="header__item">
                <h4>Tableau de bord</h4>
                <div>
                    <span>Recherche</span>
                    <!--<date-range-picker
                        ref="picker"
                        :opens="opens"
                        :locale-data="{
                            firstDay: 1,
                            format: 'dd-mm-yyyy',
                            applyLabel: 'Appliquer',
                            cancelLabel: 'Annuler',
                            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
                        }"
                        :singleDatePicker="false"
                        :timePicker="false"
                        :timePicker24Hour="false"
                        :showWeekNumbers="false"
                        :showDropdowns="true"
                        :autoApply="false"
                        v-model="dateRange"
                        @update="updateValues"
                        :linkedCalendars="true"
                        :dateFormat="dateFormat"
                    >
                    </date-range-picker>-->

                    <date-range-picker
                        ref="picker"
                        :opens="opens"
                        :locale-data="locale"
                        :singleDatePicker="false"
                        :timePicker=false
                        :showWeekNumbers="showWeekNumbers"
                        :showDropdowns="showDropdowns"
                        :autoApply="autoApply"
                        v-model="dateRange"
                        :ranges=false
                        @update="updateValues"
                        :linkedCalendars="linkedCalendars"
                        :dateFormat="dateFormat"
                        :always-show-calendars="false"
                        :alwaysShowCalendars="alwaysShowCalendars"
                        class="mb-2"
                    >
                        <div slot="footer" class="slot mb-2">
                            <div class="text-right mr-2">
                                <a class="btn btn-outline-secondary" @click.prevent="clickCancel()">Annuler</a>
                                <a class="btn btn-primary" :class="loading ? 'disabled' : ''" @click.prevent="clickApply()">Exporter</a>
                            </div>
                        </div>
                    </date-range-picker>
                </div>
            </div>
            <div class="row match-height">
                <payments :paiement="paiement"></payments>
                <admin-prospect :totalCountable="totalCountable" :totalClient="totalClient"/>
            </div>
            <subscription :subscriptions="subscriptions"></subscription>
        </div>
    </div>
</template>

<script>
    import payments from "../../../pages/dashboard/payments";
    import adminProspect from "../../../pages/dashboard/adminProspect";
    import subscription from "../../../pages/dashboard/subscription";
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import moment from "moment";
    import {api} from "../../../helpers/shared";
    export default {
        name: "index",
        components: {adminProspect, payments, subscription, DateRangePicker },
        props: {
            client:{
                type: String,
                default: () => ''
            },
            countable:{
                type: String,
                default: () => ''
            },
            sub:{
                type: String,
                default: () => ''
            },
        },
        data: () => ({
            totalClient: {},
            totalCountable: {},
            subscriptions: [],
            paiement: "0",
            opens: 'left',
            loading: false,
            showWeekNumbers: true,
            linkedCalendars: true,
            alwaysShowCalendars: true,
            showDropdowns: true,
            autoApply: false,
            locale: {
                direction: 'ltr',
                format: 'dd/mm/yyyy',
                separator: ' - ',
                applyLabel: 'Appliquer',
                cancelLabel: 'Annuler',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
                firstDay: 0
            },
            dateRange: {
                startDate: "",
                endDate: "",
            },
        }),

        mounted(){
            this.totalClient = JSON.parse(this.client);
            this.totalCountable = JSON.parse(this.countable);
            this.paiement = this.totalCountable.amount ? this.totalCountable.amount : '0';
            this.subscriptions = JSON.parse(this.sub);
        },

        methods:{
            updateValues(values) {
                this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
                this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
            },
            dateFormat(classes, date) {
                let yesterday = moment().subtract(1, 'day');
                /*
                if (!classes.disabled) {
                    classes.disabled = moment(date).isSame(yesterday, 'day')
                }
                */
                return classes;
            },
            clickCancel(){
                this.$refs.picker.clickCancel();
            },
            clickApply(){
                let loader = this.$loading.show({
                    container: null,
                    canCancel: false,
                    color: '#4B4B4B',
                    backgroundColor: '#4B4B4B',
                    height: 35,
                    width: 35,
                    loader: 'bars',
                    opacity: 0.3,
                });
                this.loading = true;
                this.$refs.picker.clickedApply();
                axios.post(api('administration/dashboard'), this.dateRange).then((response) => {
                    this.loading = false;
                    if (response.data.status){
                        let content = response.data
                        this.totalClient = content.countable.client;
                        this.totalCountable = content.countable.total;
                        this.paiement = this.totalCountable.amount ? this.totalCountable.amount : "0";
                        this.subscriptions = content.subscriptions;
                        this.$refs.picker.clickCancel();
                        let sub = [
                            {
                                "Total souscriptions": this.totalCountable.all,
                                "Souscriptions payées": this.totalCountable.paid,
                                "Souscriptions en cours": this.totalCountable.in_progress,
                                "Demandes de réduction": this.totalCountable.reduction
                            }
                        ];
                        let cust = [
                            {
                                "Prospects": this.totalClient.all,
                                "Clients": this.totalClient.total_client,
                                "Prospects validés": this.totalClient.total_validate,
                                "En attente de validation": this.totalClient.attente
                            }
                        ]
                        const worksheet1 = XLSX.utils.json_to_sheet(sub);
                        const worksheet2 = XLSX.utils.json_to_sheet(cust);
                        const workbook = {
                            Sheets: {
                                'Souscription': worksheet1,
                                'Client': worksheet2
                            },
                            SheetNames: ['Souscription','Client']
                        }
                        XLSX.writeFile(workbook, "dashboard.xlsx");
                        loader.hide()
                    }else loader.hide()
                }).catch((error) => {
                    loader.hide()
                    this.loading = false;
                    if (error.response.status !== 401){
                        this.$toasted.global.error({message: 'Votre session a expiré'})
                    }
                })
                //this.$refs.picker.clickedApply()
                /*
                clickCancel: ƒ ()
                clickRange: ƒ ()
                clickedApply: ƒ ()
                */
            }
        }
    }
</script>

<style scoped>
    .header__item{
        display: grid;
        grid-template-columns: 3fr 1fr;
    }
    .vue-daterange-picker{
        position: relative !important;
        display: inline-block !important;
        min-width: 100% !important;
    }
</style>
